import { internalLogger } from '../clientOsLogger';
import { GrantsInterface } from './GrantsInterface';
import { GrantsHookReturnType, GrantsInterfaceType } from '@clientos/types';

let grantsInterface: GrantsInterface;

export function getSessionInterfaceV1(): GrantsInterfaceType {
  return grantsInterface.getInterface();
}

export default async function initializeGrantsInterfaceV1(): Promise<GrantsInterfaceType> {
  if (grantsInterface) return grantsInterface.getInterface();
  grantsInterface = new GrantsInterface();

  return grantsInterface.getInterface();
}

export function createNoopGrantsInterface(): GrantsInterfaceType {
  return {
    refresh: function (): Promise<void> {
      /* istanbul ignore next */
      internalLogger?.debug?.d5({
        className: 'createNoopGrantsInterface',
        methodName: 'refresh()',
        message: 'Noop interface method called - returning resolved promise'
      });
      return Promise.resolve();
    },
    checkGrants: function (): Promise<boolean> {
      /* istanbul ignore next */
      internalLogger?.debug?.d5({
        className: 'createNoopGrantsInterface',
        methodName: 'checkGrants()',
        message: 'Noop interface method called - returning false'
      });
      return Promise.resolve(false);
    },
    checkPendingGrants: function (): Promise<boolean> {
      /* istanbul ignore next */
      internalLogger?.debug?.d5({
        className: 'createNoopGrantsInterface',
        methodName: 'checkPendingGrants()',
        message: 'Noop interface method called - returning false'
      });
      return Promise.resolve(false);
    },
    useReactCheckGrants: function (): GrantsHookReturnType {
      console.debug('Function not implemented.');
      return {
        data: false,
        error: null,
        loading: false,
        reload: () => Promise.resolve()
      };
    },
    useReactCheckPendingGrants: function (): GrantsHookReturnType {
      console.debug('Function not implemented.');
      return {
        data: false,
        error: null,
        loading: false,
        reload: () => Promise.resolve()
      };
    }
  };
}
